module.exports = __webpack_public_path__ + "static/media/older-broker.2ef38196.webp";